var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade-animation',[(_vm.showIframe)?_c('div',{staticClass:"iframe_box",on:{"click":_vm.closeIframe}},[_c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../assets/images/img_guide_arrows.png"),"alt":""}}),_c('div',{staticClass:"main_text"},[_c('p',[_vm._v("点击右上角")]),_c('p',[_vm._v("分享微信好友或朋友圈")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }